import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { authQueryOptions } from "@/auth/queryOptions";
import { isReportReturnPath, reportReturnParams } from "../../shared/report-return-path.js";

const searchSchema = z.object({
  error: z.string().optional(),
  returnTo: z.string().optional(),
});

export const Route = createFileRoute("/login")({
  validateSearch: searchSchema,
  beforeLoad: async ({ context, search }) => {
    const user = await context.queryClient.ensureQueryData(authQueryOptions);
    if (user) {
      const match = reportReturnParams(search.returnTo);
      if (match) {
        throw redirect({
          to: "/$companySlug/reports/$reportId",
          params: { companySlug: match.companySlug, reportId: match.reportId },
          replace: true,
        });
      }
      throw redirect({ to: "/", replace: true });
    }
  },
  component: LoginPage,
});

function LoginPage() {
  const { error, returnTo } = Route.useSearch();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-sm w-full space-y-4 p-8 border rounded-lg bg-card">
        <h1 className="text-2xl font-semibold text-center">BeProduct Dataflow</h1>
        <p className="text-center text-sm text-muted-foreground">
          Sign in with your BeProduct account.
        </p>
        {error === "no_access" && (
          <p className="text-sm text-destructive text-center">
            Your BeProduct account doesn't have access to this tool.
            Contact an administrator.
          </p>
        )}
        {error && error !== "no_access" && (
          <p className="text-sm text-destructive text-center">
            Login failed ({error}). Try again.
          </p>
        )}
        <a
          className="block w-full text-center px-4 py-2 rounded bg-primary text-primary-foreground hover:opacity-90 transition-opacity"
          href={`/api/auth/beproduct${isReportReturnPath(returnTo) ? `?returnTo=${encodeURIComponent(returnTo)}` : ""}`}
        >
          Continue with BeProduct
        </a>
      </div>
    </div>
  );
}
